import { transRgbToCxCyV2 } from './transSdlColor';
import { transLightToProp } from '@/utils/actionsHandler';

/**
 * 加载图片资源
 * @param {*} url 路径
 * @returns Promise<img>
 */
export function loadImg(url) {
    const img = new Image();

    img.src = url;
    img.crossOrigin = 'anonymous';
    // img.setAttribute('crossOrigin', '');

    return new Promise((resolve, reject) => {
      img.addEventListener('load', () => {
        console.log('img 加载成功');
        resolve(img);
      });

      img.addEventListener('error', (err) => {
        console.log('img 加载失败', img, err);
        reject(err);
      })
    })
}

/**
 * 加载js资源
 * @param {*} url 路径
 * @returns Promise<img>
 */
export function loadJs(url) {
  const script = document.createElement('script');

  script.src = url;

  document.head.appendChild(script);

  return new Promise((resolve, reject) => {
    script.addEventListener('load', () => {
      resolve();
    });

    script.addEventListener('error', (err) => {
      console.log('js 加载失败', err);

      reject(script);
    })
  })
  
}

/**
 * 获取每个px上的rgb数据
 * @param {*} data canvas获取的getImageData数据
 * @returns Array<string> ['255,255,255,255', '255,255,255,255']
 */
export function getPxSrgbByImageData(imgCanvasData) {
  const dataLength = imgCanvasData.length;
  const srgbList = [];
  let srgb = '';

  for (let i = 0; i < dataLength; i++) {
    if (i % 4 === 3) {
      srgb += imgCanvasData[i]
      srgbList.push(srgb);
      srgb = ''
    } else {
      srgb += `${imgCanvasData[i]},`
    }
  }

  return srgbList;
}

// export function transXYZtoCxCy({ X = 0, Y = 0, Z = 0 } = {}) {
//   const sum = X + Y + Z;
//   const x = X / sum;
//   const y = Y / sum;

//   const a = parseInt(x * 10000);
//   const b = parseInt(y * 10000);
//   const value = (a & 0x0000FFFF) << 16 | b & 0x0000FFFF;

//   const cx = value >> 16 & 0xffff;
//   const cy = value & 0xffff;
  
//   const cxcy = Number(value).toString(16);
//   const cxcyStr = `${cxcy}`;
//   // console.log('cxcy', cx, cy);

//   return parseInt(cxcy.length / 2) === cxcy.length / 2 ? cxcyStr : `0${cxcyStr}`; // 127140940;
// };

export function transXYZtoCxCy({ X = 0, Y = 0, Z = 0 } = {}) {
  const sum = X + Y + Z;
  const x = X / sum;
  const y = Y / sum;

  const cx = x;
  const cy = y;

  return [cx, cy]
};



/**
 * rgb转为cxcy
 * @param {*} r 
 * @param {*} g 
 * @param {*} b 
 * @returns 
 */
export function transRgbToCxCy(r, g, b) {
  const { X, Y, Z } = srgbTransXYZ(r, g, b);

  return transXYZtoCxCy({
      X, Y, Z
  })
}

/**
 * 转换色值
 * @param {*} num 
 * @returns Number
 */
function getColorXyz(num) {
  if (num > 0.04045) {
    return Math.pow((num + 0.055) / 1.055, 2.4);
  }

  return num / 12.92;
}

// /**
//  * 将rgb转换为xyz
//  * @param {*} r 
//  * @param {*} g 
//  * @param {*} b 
//  * @returns 
//  */
// export function srgbTransXYZ(r, g, b) {
//   const _r = getColorXyz(r / 255) * 100;
//   const _g = getColorXyz(g / 255) * 100;
//   const _b = getColorXyz(b / 255) * 100;

//   // return {
//   //   X: _r * 0.4124 + _g * 0.3576 + _b * 0.1805,
//   //   Y: _r * 0.2126 + _g * 0.7152 + _b * 0.0722,
//   //   Z: _r * 0.0193 + _g * 0.1192 + _b * 0.9505
//   // }

//   // 当前线上版本
//   // return {
//   //   X: _r * 0.6068909 + _g * 0.1735011 + _b * 0.2003480,
//   //   Y: _r * 0.2989164 + _g * 0.5865990 + _b * 0.1144845,
//   //   Z: _r * 0 + _g * 0.0660957 + _b * 1.1162243
//   // }
//   // 实验版本
//   return {
//     X: _r * 0.4360747 + _g * 0.3850649  + _b * 0.1430804,
//     Y: _r * 0.2225045  + _g * 0.7168786  + _b * 0.0606169,
//     Z: _r * 0.0139322  + _g * 0.0971045  + _b * 0.7141733
//   }
// }

/**
* 将rgb转换为xyz
* @param {*} r 
* @param {*} g 
* @param {*} b 
* @returns 
*/
export function srgbTransXYZ(r, g, b) {
  const _r = getColorXyz(r / 255.0) * 100;
  const _g = getColorXyz(g / 255.0) * 100;
  const _b = getColorXyz(b / 255.0) * 100;

  // 实验版本
  return {
      X: _r * 0.4360747 + _g * 0.3850649 + _b * 0.1430804,
      Y: _r * 0.2225045 + _g * 0.7168786 + _b * 0.0606169,
      Z: _r * 0.0139322 + _g * 0.0971045 + _b * 0.7141733
  }
}

/**
 * 返回dom节点
 * @param {string} container 
 * @returns dom
 */
export function querySelector(container) {
  return document.querySelector(container);
}

/**
 * srgb转换为rgb
 * @param {String} srgb 
 */
export function transRgbBySrgb(srgb) {
  const rgb = srgb.match(/^(\d+\,){2}\d+/);

  return rgb && rgb[0] ? `rgb(${rgb[0]})` : 'rgb(255, 255, 255)'; 
}

export function queryFirstCanvasChild(dom) {
  dom.querySelector('canvas');
}


export function getIndexFromRect({ x, y, directionType, width, height }){
  // const pxX = directionType === 1 ? i : index;
  // const pxY = directionType === 1 ? index : (originImgData.height  - 1) - i;
  // 横向
  // if (directionType === 1) {
    
  // }
  return y * width + x;
}

// 0.4887180  0.3106803  0.2006017
// 0.1762044  0.8129847  0.0108109
// 0.0000000  0.0102048  0.9897952

// CIE RGB
// 线性变换为XYZ颜色空间 
// var x = rCorrected * 0.4887180 + gCorrected * 0.3106803 + bCorrected * 0.2006017;
// var y = rCorrected * 0.1762044 + gCorrected * 0.8129847 + bCorrected * 0.0108109;
// var z = rCorrected * 0.0000000 + gCorrected * 0.0102048 + bCorrected * 0.9897952;


// NTSC RGB 
// 	0.6068909  0.1735011  0.2003480
// 	0.2989164  0.5865990  0.1144845
//    -0.0000000  0.0660957  1.1162243

//srgb
// 0.4124564  0.3575761  0.1804375
// 0.2126729  0.7151522  0.0721750
// 0.0193339  0.1191920  0.9503041
// var y = rCorrected * 0.2126729 + gCorrected * 0.7151522 + bCorrected * 0.0721750;


function fixedNumber(num, n) {
  num = num.toString(16);
  let len = num.length;
  while (len < n) {
    num = "0" + num;
    len++;
  }
  return  num;
}

export function handlerMatrixAction(matrixAction) {
  let dstArea = {
    sR: { x: 0.6491, y: 0.3470 },
    sG: { x: 0.4282, y: 0.5237 },
    sB: { x: 0.1995, y: 0.2199 },
  }
  // console.log('handlerMatrixAction', matrixAction);

  if (matrixAction && matrixAction.extra) {
    dstArea.sR.x = matrixAction?.extra?.xr
    dstArea.sR.y = matrixAction?.extra?.yr

    dstArea.sG.x = matrixAction?.extra?.xg
    dstArea.sG.y = matrixAction?.extra?.yg

    dstArea.sB.x = matrixAction?.extra?.xb
    dstArea.sB.y = matrixAction?.extra?.yb
  }

  return dstArea;
}

function calculateBrightness(r, g, b) {
  // 调整权重
  let adjustedR = r * 0.299;
  let adjustedG = g * 0.587;
  let adjustedB = b * 0.114;

  // 计算亮度值
  let brightness = adjustedR + adjustedG + adjustedB;

  // 将亮度值四舍五入到整数
  brightness = Math.round(brightness);

  return brightness;
}


/**
 * 根据颜色换算亮度
 * @param {*} colorData 
 * @param {*} lightProp 
 * @returns 
 */
export function transRgbToLight(colorData, lightProp) {
  const { r, g, b } = colorData;

  const maxRgb = Math.max(r, g, b);

  return Math.floor(transLightToProp(lightProp) / 100 * maxRgb);

  // const maxRgb = (r + g + b) / 765 * 255;

  // return Math.floor(transLightToProp(lightProp) / 100 * maxRgb);

// console.log('calculateBrightness(r, g, b)', calculateBrightness(r, g, b));

//   return Math.floor(transLightToProp(calculateBrightness(r, g, b)));
}

/**
 * 计算action value
 * @param light 
 * @param color 
 * 
 *     
 *  按顺序执行相应的转换
    // 因此，为了能够在天幕上正确显示图片的做法包括：
    // （1） 采用SDL1.1色域内的色彩制作图片并显示（所见即所得）（2） 将Srgb 色域的图片转换SDL1.1 色域图片并显示，具体操作步骤包括：
    // A. 对SRGB 色域图片取色，采用算法将 RGB 转换 CxCy（算法已提供），并记录亮度值 Bri（取 RGB 中最大值/255）

    // B. 采用算法对色域进行转换（本算法）
   
    // C. 将转换后的CxCy 转换为 RGB（算法已提供）  cxcy  0.33,0.33
    // D. 将RGB 值亮度调节到转之前（所有 RGB 值乘以Bri）根据不同的业务逻辑，建议以上策略可选
 */
// { x: 0, y: 0, color?: 'r,g,b,255', isShadown?: number, isOpen?: number, light?: number 
export const transformPointToCXCY = (point, dstArea) => {
  const color = point.color || ""
  let [r, g, b, a] = color.split(",").map(v => parseInt(v))

  // v1 第一个版本
  const CxCy = transRgbToCxCy(r, g, b);

  const [cx, cy] = CxCy
  const dstPoint = { x: 0, y: 0 }
  let aa = 0;
  let bb = 0;

  if (point.mode === 'V2') {
    // v2 第二个版本
    transRgbToCxCyV2(cx, cy, handlerMatrixAction(dstArea), dstPoint);

    aa = dstPoint.x * 10000
    bb = dstPoint.y * 10000
  } else {
    aa = cx * 10000
    bb = cy * 10000
  }
  
  // console.log('dstPoint', dstPoint);
  
  // const aa = dstPoint.x * 10000
  // const bb = dstPoint.y * 10000
  const value = (aa & 0x0000FFFF) << 16 | bb & 0x0000FFFF;

  const cxcy = Number(value).toString(16);

  const cxcyResult = fixedNumber(value, 8);

  const lightValue = ('0' + Number(transRgbToLight({ r, g, b }, point.light)).toString(16)).slice(-2);
  const strResult = `${lightValue}${cxcyResult}`;


  return strResult
}

export const transformPointToSdlRgb = (point, dstArea) => {
  const color = point.color || ""
  let [r, g, b, a] = color.split(",").map(v => parseInt(v))

  // v1 第一个版本
  const CxCy = transRgbToCxCy(r, g, b);

  const [cx, cy] = CxCy
  const dstPoint = { x: 0, y: 0 }
  let aa = 0;
  let bb = 0;

  if (point.mode === 'V2') {
    // v2 第二个版本
    transRgbToCxCyV2(cx, cy, handlerMatrixAction(dstArea), dstPoint);

    aa = dstPoint.x * 10000
    bb = dstPoint.y * 10000
  } else {
    aa = cx * 10000
    bb = cy * 10000
  }
  
  return OppColorCvrtCIExy2sRgb(dstPoint)
}

/**
 * @brief 色坐标转sRGB
 * 
 * @param {Object} pxy 输入色坐标
 * @param {number} cieY Y值
 * @param {Object} rgb 输出RGB值
 */
function OppColorCvrtCIExyY2sRgb(pxy, cieY, rgb) {
  // 计算RGB颜色值  
  let X, Y, Z, r, g, b;

  Y = cieY * 100;
  X = pxy.x * Y / pxy.y;
  Z = (1 - pxy.x - pxy.y) * Y / pxy.y;

  X = X / 100;
  Y = Y / 100;
  Z = Z / 100;

  r = X * 3.1338561 + Y * -1.6168667 + Z * -0.4906146;
  g = X * -0.9787684 + Y * 1.9161415 + Z * 0.0334540;
  b = X * 0.0719453 + Y * -0.2289914 + Z * 1.4052427;

  if (r > 0.0031308) {
    r = 1.055 * Math.pow(r, 1 / 2.4) - 0.055;
  } else {
    r = 12.92 * r;
  }
  if (g > 0.0031308) {
    g = 1.055 * Math.pow(g, 1 / 2.4) - 0.055;
  } else {
    g = 12.92 * g;
  }
  if (b > 0.0031308) {
    b = 1.055 * Math.pow(b, 1 / 2.4) - 0.055;
  } else {
    b = 12.92 * b;
  }

  r = r * 255;
  g = g * 255;
  b = b * 255;

  rgb.r = r;
  rgb.g = g;
  rgb.b = b;
};

/**
 * @brief 色坐标转sRGB
 * 
 * @param {Object} psCIECxCy 输入色坐标(范围:0 - 1.0),只需要输入x,y,不需要输入Y值
 * @param {Object} psSRGB 输出RGB值(范围:0 - 255)
 * @retval {number} 0:成功,其他:失败错误码(1:空指针,2:参数错误)
 */
export function OppColorCvrtCIExy2sRgb(psCIECxCy) {
  let left = 0, right = 1.0, mid = 0.5, d = 256;
  let sRGB = { r: 0, g: 0, b: 0 };
  let cieY;

  // if (psSRGB === null || psCIECxCy === null) {
  //     return 1;
  // }

  while (d < 255 || d > 255.5) {
    cieY = mid;
    OppColorCvrtCIExyY2sRgb(psCIECxCy, cieY, sRGB);
    d = Math.max(sRGB.r, sRGB.g, sRGB.b);

    if (d > 255) {
        right = mid;
    } else {
        left = mid;
    }
    mid = (right - left) / 2 + left;
      // console.log(left, right, mid, d);
  };

  // psSRGB.r = sRGB.r < 0 ? 0 : sRGB.r;
  // psSRGB.g = sRGB.g < 0 ? 0 : sRGB.g;
  // psSRGB.b = sRGB.b < 0 ? 0 : sRGB.b;

  return {
    r: sRGB.r < 0 ? 0 : Math.floor(sRGB.r),
    g: sRGB.g < 0 ? 0 : Math.floor(sRGB.g),
    b: sRGB.b < 0 ? 0 : Math.floor(sRGB.b)
  };
  // return 0;
}

export const rgbToHex = (red, green, blue) => {
  const toHex = (colorValue) => {
    let hex = colorValue.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  };
 
  return "#" + toHex(red) + toHex(green) + toHex(blue);
}